var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 9c0-3.86-3.14-7-7-7-2.825 0-5.258 1.685-6.363 4.1l-2.223-1.01a.995.995 0 0 0-.828 0l-11 5A1 1 0 0 0 2 11v13a1 1 0 0 0 .586.91l11 5a.994.994 0 0 0 .828 0l11-5A1 1 0 0 0 26 24v-8.685c2.36-1.126 4-3.53 4-6.315zM14 7.099l2.074.942a6.995 6.995 0 0 0-.074.96c0 1.626.563 3.121 1.497 4.311L14 14.902 5.417 11zM4 12.553l9 4.09v10.804l-9-4.091zm20 10.803-9 4.09V16.645l4.074-1.852A6.96 6.96 0 0 0 23 16c.34 0 .672-.033 1-.08zM23 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.372 5.071a1 1 0 0 0-1.3.557l-1.437 3.593-.928-.928a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.636-.335l2-5a1 1 0 0 0-.557-1.3z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.5d70b926ca6e7e464cdbe970aa9845fc.svg";
export { ForwardRef as ReactComponent };